var React = require('react');

function Document (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",null,React.createElement("g",null,React.createElement("g",{"transform":"translate(-203 -4158) translate(203 4155) translate(0 3)"},[React.createElement("rect",{"width":"13","height":"16","fill":"#C3CAD2","rx":"2","key":0}),React.createElement("rect",{"width":"8","height":"1","x":"2.5","y":"3","fill":"#1B232D","rx":".5","key":1}),React.createElement("rect",{"width":"8","height":"1","x":"2.5","y":"6","fill":"#1B232D","rx":".5","key":2}),React.createElement("rect",{"width":"8","height":"1","x":"2.5","y":"9","fill":"#1B232D","rx":".5","key":3}),React.createElement("rect",{"width":"4","height":"1","x":"6.5","y":"12","fill":"#1B232D","rx":".5","key":4})])))));
}

Document.defaultProps = {"width":"13","height":"16","viewBox":"0 0 13 16"};

module.exports = Document;

Document.default = Document;
